import { fakerCZ } from '@speedlo/testing/dist/faker'

export const faker = fakerCZ
